import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=4290ed50&"
import script from "./DocumentPage.vue?vue&type=script&lang=ts&"
export * from "./DocumentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports